
// import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import '@babel/polyfill';
import 'react-app-polyfill/ie11';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store/appStore';
import './style/main.less';
import 'regenerator-runtime/runtime';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, API_SCOPES } from "./msalConfig";
import { setAccount } from './store/auth/actions';
import { clearLegacyMsalCache } from './msalCacheMigration';

const redirectRequest = { scopes: API_SCOPES };

const renderApp = () => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
};

(async () => {
  try {
    clearLegacyMsalCache();

    await msalInstance.initialize();

    const response = await msalInstance.handleRedirectPromise();

    if (response && response.account) {
      msalInstance.setActiveAccount(response.account);
      store.dispatch(setAccount(response.account));
    } else {
      const account = getValidAccount();

      if (account) {
        msalInstance.setActiveAccount(account);
        store.dispatch(setAccount(account));
        try {
          await msalInstance.acquireTokenSilent({ ...redirectRequest, account });
        } catch (err) {
          console.warn("Silent token failed for valid account, redirecting", err);
          msalInstance.loginRedirect(redirectRequest);
          return;
        }
      } else {
        // No valid accounts → force login
        msalInstance.loginRedirect(redirectRequest);
        return;
      }      
    }

    renderApp();
  } catch (e) {
    console.error("MSAL bootstrap error:", e);
    renderApp();
  }
})();

function isIdTokenExpired(account) {
  if (!account?.idTokenClaims?.exp) {
    return true; // no token info → treat as expired
  }

  const expiry = account.idTokenClaims.exp * 1000; // convert to ms
  const now = Date.now();

  return now >= expiry;
}

function getValidAccount() {
  const active = msalInstance.getActiveAccount();
  if (active && !isIdTokenExpired(active)) {
    return active;
  }

  const accounts = msalInstance.getAllAccounts();
  const validAccounts = accounts.filter(acc => !isIdTokenExpired(acc));

  return validAccounts.length > 0 ? validAccounts[0] : null;
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
